
import React from 'react';

export const useComponentStyle = (style: string) => {
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    const link = document.createElement('style');
    link.append(style as any);
    link.onload = () => setIsReady(true);

    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [style]);

  return isReady;
};